import { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

import { immersiveSaveButtonContainerId } from './utils'

import { useAppSelector } from 'hooks/reduxHooks'
import useHasMounted from 'hooks/useHasMounted'
import { getImmersiveTripId } from 'tripPlanner/selectors'

/*
  Renders its children (i.e. "Save to trip" buttons) into the immersive trip header.

  The benefit of using a portal to do this, is that the save button can be rendered
  from within contexts such as the offer page context. Then we can save data such as
  selected dates into the trip item.
*/
function ImmersiveSaveButtonPortal({ children }: PropsWithChildren) {
  // useAppSelector here just to force the component to re-render
  // if we've gone into immersive mode.
  useAppSelector(getImmersiveTripId)

  // Can't render this on the server due to use of portal
  if (!useHasMounted()) {
    return null
  }

  const container = document.getElementById(immersiveSaveButtonContainerId)

  if (!container) {
    return null
  }

  return createPortal(children, container)
}

export default ImmersiveSaveButtonPortal
